module.exports = __webpack_public_path__ + "img/Live_class.4eb01d9a.png";